const KEY = 'mx_onboarded_v1';

export function isOnboarded(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    // localStorage недоступен — считаем «уже видел», чтобы не блочить вход.
    return true;
  }
}

export function markOnboarded(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    /* noop */
  }
}

export function resetOnboarded(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
